// extracted by mini-css-extract-plugin
export default {"container":"QkYQzS","unit":"mT2U3V","text":"ubD_7K","block":"saOzDS","layer1":"x3oOah","layer2":"E4cP8s","layer3":"BjEu7H","layer4":"H7MgAW"};